import { createContext, useCallback, useContext, useEffect, useState } from "react";

const dict = {
  en: {
    "nav.matrimony": "Matrimony",
    "nav.jobs": "Jobs",
    "nav.marketplace": "Marketplace",
    "nav.training": "Training",
    "nav.games": "Play & Earn",
    "nav.doctor": "Doctor",
    "nav.doctors": "Doctors",
    "nav.lawyers": "Lawyers",
    "nav.events": "Events",
    "nav.coupons": "Coupons",
    "nav.prints": "My Prints",
    "nav.support": "Support",
    "nav.login": "Login",
    "nav.join": "Join Anveshan",
    "nav.logout": "Logout",
    "nav.orders": "My Orders",

    "landing.chip": "Anveshan — over 12,000 families",
    "landing.h1a": "Every service your",
    "landing.h1b": "samaj",
    "landing.h1c": "needs, in one warm place.",
    "landing.sub": "Anveshan brings matrimony, jobs, marketplace, free training, community games and a doctor at your side — built for the people you already trust.",
    "landing.cta.join": "Join the community",
    "landing.cta.training": "Free training programs",

    "market.title.a": "Buy",
    "market.title.b": "fresh",
    "market.title.c": "or",
    "market.title.d": "second-hand",
    "market.subtitle": "Both brand-new stock from community sellers and trusted used goods from neighbours.",
    "market.sell": "Sell something",
    "market.tab.all": "All",
    "market.tab.fresh": "Fresh Products",
    "market.tab.second": "Second Hand",
    "market.book_now": "Book Now",
    "market.upi_inr": "UPI / INR",
    "market.cod": "Cash on Delivery",
    "market.sold": "Sold",
    "market.reserved": "Reserved",
    "market.feature_credits": "Feature (200 credits)",
    "market.boost_stripe": "Boost $3",
    "market.featured": "Featured",

    "orders.title": "My Orders",
    "orders.sub": "Track every purchase and sale — coupon payments and Cash on Delivery.",
    "orders.tab.buyer": "As buyer",
    "orders.tab.seller": "As seller",
    "orders.status.pending": "Awaiting payment",
    "orders.status.paid": "Paid",
    "orders.status.cod_pending": "COD pending",
    "orders.status.cod_delivered": "Delivered · cash collected",
    "orders.status.cancelled": "Cancelled",
    "orders.mark_delivered": "Mark delivered · cash received",
    "orders.cancel": "Cancel order",
    "orders.none": "No orders yet.",
  },
  hi: {
    "nav.matrimony": "विवाह",
    "nav.jobs": "नौकरी",
    "nav.marketplace": "बाज़ार",
    "nav.training": "प्रशिक्षण",
    "nav.games": "खेलें और कमाएँ",
    "nav.doctor": "डॉक्टर",
    "nav.doctors": "डॉक्टर्स",
    "nav.lawyers": "वकील",
    "nav.events": "आयोजन",
    "nav.coupons": "कूपन",
    "nav.prints": "मेरे प्रिंट",
    "nav.support": "सहायता",
    "nav.login": "लॉगिन",
    "nav.join": "अन्वेषण से जुड़ें",
    "nav.logout": "लॉगआउट",
    "nav.orders": "मेरे ऑर्डर",

    "landing.chip": "अन्वेषण — 12,000+ परिवार",
    "landing.h1a": "आपके",
    "landing.h1b": "समाज",
    "landing.h1c": "की हर ज़रूरत, एक ही जगह।",
    "landing.sub": "विवाह, नौकरी, बाज़ार, मुफ्त प्रशिक्षण, कम्युनिटी गेम्स और आपके साथ डॉक्टर — जिन लोगों पर आप पहले से भरोसा करते हैं, उन्हीं के लिए बना।",
    "landing.cta.join": "समुदाय से जुड़ें",
    "landing.cta.training": "मुफ्त प्रशिक्षण देखें",

    "market.title.a": "खरीदें",
    "market.title.b": "ताज़ा",
    "market.title.c": "या",
    "market.title.d": "पुराना",
    "market.subtitle": "कम्युनिटी विक्रेताओं का बिल्कुल नया सामान और पड़ोसियों का भरोसेमंद पुराना सामान — दोनों यहीं।",
    "market.sell": "कुछ बेचें",
    "market.tab.all": "सभी",
    "market.tab.fresh": "ताज़ा उत्पाद",
    "market.tab.second": "पुराना सामान",
    "market.book_now": "अभी बुक करें",
    "market.upi_inr": "UPI / ₹",
    "market.cod": "कैश ऑन डिलीवरी",
    "market.sold": "बिक चुका",
    "market.reserved": "रिज़र्व्ड",
    "market.feature_credits": "फ़ीचर करें (200 क्रेडिट)",
    "market.boost_stripe": "बूस्ट $3",
    "market.featured": "फ़ीचर्ड",

    "orders.title": "मेरे ऑर्डर",
    "orders.sub": "हर खरीद और बिक्री को ट्रैक करें — कूपन भुगतान और कैश ऑन डिलीवरी।",
    "orders.tab.buyer": "खरीदार के रूप में",
    "orders.tab.seller": "विक्रेता के रूप में",
    "orders.status.pending": "भुगतान बाकी",
    "orders.status.paid": "भुगतान हुआ",
    "orders.status.cod_pending": "COD बाकी",
    "orders.status.cod_delivered": "पहुँचा · नकद मिला",
    "orders.status.cancelled": "रद्द",
    "orders.mark_delivered": "पहुँचा · नकद मिला दर्ज करें",
    "orders.cancel": "ऑर्डर रद्द करें",
    "orders.none": "अभी कोई ऑर्डर नहीं।",
  },
  bn: {
    "nav.matrimony": "বিবাহ", "nav.jobs": "চাকরি", "nav.marketplace": "বাজার",
    "nav.training": "প্রশিক্ষণ", "nav.games": "খেলা ও উপার্জন", "nav.doctor": "ডাক্তার",
    "nav.doctors": "ডাক্তার", "nav.lawyers": "আইনজীবী", "nav.events": "অনুষ্ঠান",
    "nav.coupons": "কুপন", "nav.support": "সহায়তা",
  },
  mr: {
    "nav.matrimony": "विवाह", "nav.jobs": "नोकऱ्या", "nav.marketplace": "बाजार",
    "nav.training": "प्रशिक्षण", "nav.games": "खेळा आणि कमवा", "nav.doctor": "डॉक्टर",
    "nav.doctors": "डॉक्टर", "nav.lawyers": "वकील", "nav.events": "कार्यक्रम",
    "nav.coupons": "कूपन", "nav.support": "मदत",
  },
  gu: {
    "nav.matrimony": "લગ્ન", "nav.jobs": "નોકરી", "nav.marketplace": "બજાર",
    "nav.training": "તાલીમ", "nav.games": "રમો અને કમાવ", "nav.doctor": "ડૉક્ટર",
    "nav.doctors": "ડૉક્ટર", "nav.lawyers": "વકીલ", "nav.events": "કાર્યક્રમો",
    "nav.coupons": "કૂપન", "nav.support": "સહાય",
  },
  ta: {
    "nav.matrimony": "திருமணம்", "nav.jobs": "வேலைகள்", "nav.marketplace": "சந்தை",
    "nav.training": "பயிற்சி", "nav.games": "விளையாடி சம்பாதி", "nav.doctor": "மருத்துவர்",
    "nav.doctors": "மருத்துவர்கள்", "nav.lawyers": "வழக்கறிஞர்கள்", "nav.events": "நிகழ்வுகள்",
    "nav.coupons": "கூப்பன்கள்", "nav.support": "ஆதரவு",
  },
  te: {
    "nav.matrimony": "వివాహం", "nav.jobs": "ఉద్యోగాలు", "nav.marketplace": "మార్కెట్",
    "nav.training": "శిక్షణ", "nav.games": "ఆడి సంపాదించండి", "nav.doctor": "వైద్యుడు",
    "nav.doctors": "వైద్యులు", "nav.lawyers": "న్యాయవాదులు", "nav.events": "కార్యక్రమాలు",
    "nav.coupons": "కూపన్లు", "nav.support": "మద్దతు",
  },
  pa: {
    "nav.matrimony": "ਵਿਆਹ", "nav.jobs": "ਨੌਕਰੀਆਂ", "nav.marketplace": "ਬਾਜ਼ਾਰ",
    "nav.training": "ਸਿਖਲਾਈ", "nav.games": "ਖੇਡੋ ਤੇ ਕਮਾਓ", "nav.doctor": "ਡਾਕਟਰ",
    "nav.doctors": "ਡਾਕਟਰ", "nav.lawyers": "ਵਕੀਲ", "nav.events": "ਸਮਾਗਮ",
    "nav.coupons": "ਕੂਪਨ", "nav.support": "ਸਹਾਇਤਾ",
  },
};

export const LANG_OPTIONS = [
  { code: "en", label: "English" },
  { code: "hi", label: "हिन्दी" },
  { code: "bn", label: "বাংলা" },
  { code: "mr", label: "मराठी" },
  { code: "gu", label: "ગુજરાતી" },
  { code: "ta", label: "தமிழ்" },
  { code: "te", label: "తెలుగు" },
  { code: "pa", label: "ਪੰਜਾਬੀ" },
];

const LangContext = createContext({ lang: "en", setLang: () => {}, t: (k) => k });

export function LangProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("anv_lang") || "en");
  useEffect(() => { document.documentElement.lang = lang; }, [lang]);
  const setLang = useCallback((l) => {
    localStorage.setItem("anv_lang", l);
    setLangState(l);
  }, []);
  const t = useCallback((key) => (dict[lang] && dict[lang][key]) || dict.en[key] || key, [lang]);
  return <LangContext.Provider value={{ lang, setLang, t }}>{children}</LangContext.Provider>;
}

export const useLang = () => useContext(LangContext);
